module.exports = __webpack_public_path__ + "static/media/slide4.d29bf0d8.jpg";